import FastMarquee from "react-fast-marquee";
import { Diamond } from "lucide-react";

const ITEMS = [
  "SUPPLY CHAIN OPTIMISATION",
  "IN-COUNTRY VALUE",
  "40+ YEARS EXPERIENCE",
  "DEFENCE · GOVERNMENT · MINING",
  "FLEXIBLE CAPACITY",
  "CAPABILITY TRANSFER",
  "LOCAL & OVERSEAS",
];

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-white/10 bg-[#02060D] py-6 overflow-hidden"
      aria-hidden="true"
    >
      <FastMarquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-display text-2xl md:text-4xl tracking-tight text-slate-500 px-8 whitespace-nowrap">
              {item}
            </span>
            <Diamond className="h-3.5 w-3.5 text-teal-400" fill="currentColor" />
          </span>
        ))}
      </FastMarquee>
    </div>
  );
}
